import { v4 } from "uuid"

const excludedGeoLocationAppend = ({ commit }, geoLocation) => {
  commit("EXCLUDED_GEO_LOCATION_APPEND", geoLocation)
}

const excludedGeoLocationRemove = ({ commit }, geoLocation) => {
  commit("EXCLUDED_GEO_LOCATION_REMOVE", geoLocation)
}

const excludedGeoLocationUpdate = ({ commit }, geoLocation) => {
  commit("EXCLUDED_GEO_LOCATION_UPDATE", geoLocation)
}

const excludedInterestsAppend = ({ commit }, items) => {
  commit("EXCLUDED_INTERESTS_APPEND", items)
}

const excludedInterestsRemove = ({ commit }, items) => {
  commit("EXCLUDED_INTERESTS_REMOVE", items)
}

const geoLocationAppend = ({ commit }, geoLocation) => {
  commit("GEO_LOCATION_APPEND", geoLocation)
}

const geoLocationRemove = ({ commit }, geoLocation) => {
  commit("GEO_LOCATION_REMOVE", geoLocation)
}

const geoLocationUpdate = ({ commit }, geoLocation) => {
  commit("GEO_LOCATION_UPDATE", geoLocation)
}

const interestsAppend = ({ commit }, { group, items }) => {
  commit("INTERESTS_APPEND", { group, items })
}

const interestsRemove = ({ commit }, { group, items }) => {
  commit("INTERESTS_REMOVE", { group, items })
}

const interestsGroupAppend = ({ commit }) => {
  const group = {
    id: v4(),
    items: [],
  }

  commit("INTERESTS_GROUP_APPEND", group)
}

const interestsGroupRemove = ({ commit }, group) => {
  commit("INTERESTS_GROUP_REMOVE", group)
}

export {
  excludedGeoLocationAppend,
  excludedGeoLocationRemove,
  excludedGeoLocationUpdate,
  excludedInterestsAppend,
  excludedInterestsRemove,
  geoLocationAppend,
  geoLocationRemove,
  geoLocationUpdate,
  interestsAppend,
  interestsRemove,
  interestsGroupAppend,
  interestsGroupRemove,
}
